import { Component, EventEmitter, OnInit, QueryList } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IVclAutocompleteEvent } from '@voxel/community';
import { CopyService } from '../../shared/services/copies/copy.service';
import { ApplicationService } from '../../shared/services/application/application.service';
import { ISolicitation } from '../../shared/models/solicitation-models/solicitation/SolicitationModel';
import { RequestSolicitationsService } from '../../shared/services/solicitations/request-solicitations.service';
import { CatalogService, EPersonType } from '../../shared/services/catalogs/catalog.service';
import { getValueProperty, setValueProperty } from '../../shared/helpers/functions.helpers';
import { BaseComponent } from '../../shared/components/base-component';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { EVENT } from '../../shared/constants/dali.constants';
import { ClientValidationService, IRequestClientValidation } from '../../shared/services/solicitations/client-validation.service';
import { EDocumentTypeId } from '../form-solicitation-basic-data/form-solicitation-basic-data.component';

@Component({
  selector: 'app-requirements-start',
  templateUrl: './requirements-start.component.html',
  styleUrls: ['./requirements-start.component.scss']
})
export class RequirementsStartComponent extends BaseComponent implements OnInit {
  stepsInformation: QueryList<any> | undefined;
  chkDisable: any;
  form: FormGroup = this.fb.group({
    basic_data: this.fb.group({}),
    terms_form: this.fb.group({}),
    'filter': new FormControl('', Validators.nullValidator)
  });

  /**
   * Contiene los textos y etiquetas
   */
  CONTENT_BOUNDS: any[] | any;

  /**
   * Almacena los pasos del formulario
   */
  stepsList: string[] = [];

  /**
   * Almacena los datos digitados por el cliente en pasos anteriores
   */
  //requirementData: IRequirement = {};

  ev: EventEmitter<IVclAutocompleteEvent> | any = new EventEmitter<IVclAutocompleteEvent>(true);
  solicitationData: ISolicitation = {};
  modalAShow = false;
  solicitationTypes: QueryList<any> | any;
  _solicitationTypes: QueryList<any> | any;
  filter: any = {};
  option: boolean = true;
  isLoading = false;

  /**
     * Constructor de la clase SolicitationStartComponent
     * @param _requirements Servicio para la manipulacion del estado de la solicitud
     * @param cps Servicio para la carga de textos estaticos
     * @param fb Clase encargada de cla creación y manipulación de formularios
     */

  constructor(
    private readonly _solicitation: RequestSolicitationsService,
    private readonly cps: CopyService,
    private readonly fb: FormBuilder,
    private readonly clientValidation: ClientValidationService,
    public app: ApplicationService,
    private readonly catalog: CatalogService,
    private readonly link: LinkupService
  ) {
    super(app, link, "requirements-start");
  }

  ngOnInit(): void {
    this.loadStaticValues().finally(() => {
      super.onLoad();
    });
    this.loadData();
  }

  async loadStaticValues() {
    await super.loadStaticValues();
    this.form.addControl("customer_loaded", this.fb.control(false, []));
    this.form.addControl("customer_exists", this.fb.control(false, []));
    this.form.addControl("customer_error", this.fb.control(false, []));
    this.app.channelId = "160";
    this.catalog.clearCache();
    this.CONTENT_BOUNDS = await this.cps.getCopy("requirements-start");
    this.stepsList = await this.cps.getCopy("stepList", []);
  }

  /**
   * Permite cargar la información proveniente de los pasos anteriores
   */
  loadData() {
    this.solicitationData = this._solicitation.solicitation;
  }

  async navigateTo(start: any) {
    if (start === "next") {
      let changedoc = false;
      if (getValueProperty(this._solicitation.solicitation.basicData, "document_number", "") !== this.basicDataForm.get("document_number")?.value)
        changedoc = true;
      const documentType = getValueProperty(this.basicDataForm.get('document_type'), 'value');
      const documentNumber = getValueProperty(this.basicDataForm.get('document_number'), 'value');
      const requestData: IRequestClientValidation = {
        document_number: documentNumber,
        document_type: documentType,
        solicitation_application: this.app.currentApplication
      };
      this.isLoading = true;

      const client_basic = await this.clientValidation.send(requestData, 'form-requirements-basic-data');

      let customerType = (documentType === EDocumentTypeId.CF) ? EPersonType.PERSON_TYPE_JUR : EPersonType.PERSON_TYPE_NAT;

      if (this.solicitationData.additionalData) {
        setValueProperty(this.solicitationData.additionalData, 'CustomerTypes', customerType);
      } else {
        this.solicitationData.additionalData = {
          SolicitationType: '',
          SolicitationSubtype: '',
          Annotations: '',
          Cell: { id: '', name: '' },
          CustomerTypes: customerType
        };
      }

      if (client_basic.message) {
        this.form.patchValue({
          customer_exists: false,
          customer_loaded: false,
          customer_error: true,
        });
      }
      else if (getValueProperty(client_basic, "data.client_exists")) {
        this.basicDataForm.patchValue({
          customer_exists: true,
          customer_loaded: true,
          customer_error: false
        });
        this.solicitationData.basicData = this.basicDataForm.value;
        /*if (changedoc) {
          this.solicitationData.contactsData = client_basic.contactsData;
          this.solicitationData.additionalData = client_basic.additionalData;
          this.solicitationData.risknvlData = client_basic.risknvlData;
        }*/
        this._solicitation.solicitation = this.solicitationData;
        await this._solicitation.navigation.nextStep();
        let eventSetting = this.getSetting("analytics", "trackEvent.e5", "");
        let pageSetting = this.getSetting("analytics", "pageLoad", "");
        let events = [
          {
            "name": "{EVENT.pv2E5setData.pv2E5transactionName.path}",
            "value": EVENT.pv2E5setData.pv2E5transactionName.value
          },
          {
            "name": "{EVENT.pv2E5setData.pv2E5transactionProductCategory.path}",
            "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
          },
          {
            "name": "{EVENT.pv2E5setData.pv2E5transactionProductDetails.path}",
            "value": "Fideicomiso"
          }
        ];
        setValueProperty(eventSetting, "events", events);
        this.onEvent(eventSetting);
      }
      else {
        this.form.patchValue({
          customer_exists: false,
          customer_loaded: true,
          customer_error: false,
          basic_data: {
            document_number: null
          }
        });
      }
      this.isLoading = false;

    } else {
      await this._solicitation.navigation.previousStep();
    }
  }

  onCloseEvent($event: any) {
    console.log('close event', $event);
  }

  get basicDataForm(): FormGroup {
    return this.form.get('basic_data') as FormGroup;
  }

  onCloseModal(event: any) {
    this.chkDisable = false;
  }

  onOpenModal() {
    this.chkDisable = true;
  }



  get customerLoaded(): FormControl {
    return this.form.get('customer_loaded') as FormControl;
  }

  /**
   * Permite obtener la referencia al control customer_loaded
   */
  get customerExists(): FormControl {
    return this.form.get('customer_exists') as FormControl;
  }

  /**
   * Permite obtener la referencia al control customer_error
   */
  get customerError(): FormControl {
    return this.form.get('customer_error') as FormControl;
  }


  get termsForm(): FormGroup {
    return this.form.get('terms_form') as FormGroup;
  }
}
